<template>
  <v-row justify="center" v-if="type">
    <confirm-popup v-if="type === 'confirm'" :data="data" @close="close()"></confirm-popup>
    <message-popup v-else-if="type === 'message'" :data="data" @close="close()"></message-popup>
  </v-row>
</template>
<script>
    import ConfirmPopup from "../components/popup/Confirm";
    import MessagePopup from "../components/popup/Message";
    export default {
        name: 'popup',
        components: {ConfirmPopup, MessagePopup},
        data() {
            return {
                data: null,
                type: null
            };
        },
        created() {
            this.$store.subscribe((mutation, state) => {

                if (!mutation.type.includes("popup/"))
                    return;

                if (mutation.type === "popup/SHOW_MESSAGE") {
                    this.type = 'message';
                } else if (mutation.type === "popup/SHOW_CONFIRM") {
                    this.type = 'confirm';
                } else if (mutation.type === "popup/CLOSE_DIALOG") {
                    this.type = null;
                }

                this.data = state.popup.data;
            });
        },
        methods: {
            close(){
                this.type = null;
            }
        }
    };
</script>